import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { HelpersService } from '../../../../core/services/helpers.service';
import { OperationsService } from '../../../../core/services/operations.service';
import { AssociativaAltrePartiForm } from '../../../form/associativa-altreparti-form';

import { AltraParte } from '../../../models/altraparte';

import { SezioneAltrePartiResponse } from '../../../models/dto/sezione-altre-parti-response';

import { Parte } from '../../../models/parte';
import { SezioneAltreParti } from '../../../models/sezioni/sezione-altre-parti';

@Component({
    selector: 'div [associativa-altre-parti-form-add]',
  templateUrl: '../../../form/associativa-altreparti-form.html'
})
export class AltrePartiAssociativaAddComponent extends AssociativaAltrePartiForm  implements OnInit {
  addAltraParteUrl: string;
  idSezione: string;
  idFascicolo: string;

  @Output() onReturn: EventEmitter<SezioneAltreParti> = new EventEmitter<SezioneAltreParti>();

  ngOnInit() {
    this.isInserimento(true);
  }

  constructor(@Inject(FormBuilder) campiForm: FormBuilder, @Inject(OperationsService) operationService: OperationsService, @Inject(HelpersService) helpers: HelpersService) {
      super(operationService, campiForm, helpers);
  }

  getRequest(request: AltraParte) {
    this.operationService.addParteOrLegaleInSezOrdinario(request, this.addAltraParteUrl, this.idSezione, this.idFascicolo).subscribe(
      response => this.addedAltraParte(<SezioneAltrePartiResponse> response));
  }

  addedAltraParte(response: SezioneAltrePartiResponse) {
    if (response.returnCode === 'OK') {
      this.onReturn.emit(response.sezione);
    }
  }

  getAltraParte(): AltraParte {
    return new AltraParte();
  }

  inizializza(parte: Parte, addAltraParteUrl: string, idSezione: string, idFascicolo: string, urlSezioneControparti: string, idSezioneControparti: string) {
    this.idSezione = idSezione;
    this.idFascicolo = idFascicolo;
    this.addAltraParteUrl = addAltraParteUrl;
    this.setParte(parte);
    this.populateSelect(urlSezioneControparti, idSezioneControparti);
    this.createForm();
  }
}
